/**
 * PageLoader - Composant de chargement pour les pages lazy-loaded
 */

export function PageLoader() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50/30 to-purple-50/30 dark:from-gray-900 dark:via-gray-900 dark:to-gray-900 flex items-center justify-center">
      <div className="text-center">
        <div className="relative w-16 h-16 mx-auto mb-4">
          <div className="absolute inset-0 rounded-full border-4 border-blue-200 dark:border-blue-900"></div>
          <div className="absolute inset-0 rounded-full border-4 border-blue-600 border-t-transparent animate-spin"></div>
        </div>
        <p className="text-gray-600 dark:text-gray-400 animate-pulse">Chargement...</p>
      </div>
    </div>
  );
}

/**
 * InlineLoader - Loader plus petit pour les composants inline
 */
export function InlineLoader() {
  return (
    <div className="flex items-center justify-center p-8">
      <div className="relative w-8 h-8">
        <div className="absolute inset-0 rounded-full border-2 border-blue-200 dark:border-blue-900"></div>
        <div className="absolute inset-0 rounded-full border-2 border-blue-600 border-t-transparent animate-spin"></div>
      </div>
    </div>
  );
}
